import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Driver } from '@common-module/modelinterfaces/driver.model';
import { UnitShort } from '@common-module/modelinterfaces/unit-short.model';
import { DialogComponent } from '@common-module/dialog/dialog/dialog.component';
import { DialogContentDirective } from '@common-module/dialog/dialog/dialog-content.directive';
import { DialogActionsDirective } from '@common-module/dialog/dialog/dialog-actions.directive';
import { ButtonCancelComponent } from '@common-module/buttons/base/concrete/button-cancel/button-cancel.component';
import { ButtonPrimaryComponent } from '@common-module/buttons/base/style/button-primary/button-primary.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-remove-driver-dialog',
    templateUrl: './remove-driver-dialog.component.html',
    styleUrls: ['./remove-driver-dialog.component.scss', '../../../../../../../common-module/src/lib/app-styles/dialog-common.scss'],
    imports: [DialogComponent, DialogContentDirective, DialogActionsDirective, ButtonCancelComponent, ButtonPrimaryComponent, TranslateModule]
})

export class RemoveDriverDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { driver: Driver, unit: UnitShort },
              private dialogRef: MatDialogRef<RemoveDriverDialogComponent>) {
  }

  public onCancel(): void {
    this.dialogRef.close();
  }

  public onRemove(): void {
    this.dialogRef.close(true);
  }
}
